(function () {
  'use strict';

  const sections = document.querySelectorAll('.v2-favorites');

  sections.forEach(function (section) {
    /* ===== List hover/focus → image switch ===== */
    const links = section.querySelectorAll('[data-fav-target]');
    const images = section.querySelectorAll('[data-fav-index]');

    const bgLayers = section.querySelectorAll('[data-fav-bg]');

    function setActive(index) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.favTarget == index);
      });
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.favIndex == index);
      });
      bgLayers.forEach(function (layer) {
        layer.classList.toggle('is-active', layer.dataset.favBg == index);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        setActive(link.dataset.favTarget);
      });
      link.addEventListener('focus', function () {
        setActive(link.dataset.favTarget);
      });
    });

    /* ===== Hotspot → modal ===== */
    const triggers = section.querySelectorAll('[data-fav-modal-trigger]');
    const modals = section.querySelectorAll('[data-fav-modal]');
    let lastFocus = null;

    function openModal(index) {
      const modal = section.querySelector('[data-fav-modal="' + index + '"]');
      if (!modal) return;
      lastFocus = document.activeElement;
      modal.removeAttribute('hidden');
      // Force reflow so the transition runs
      // eslint-disable-next-line no-unused-expressions
      modal.offsetHeight;
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.documentElement.classList.add('v2-fav-modal-lock');
      document.body.classList.add('v2-fav-modal-lock');
      const closeBtn = modal.querySelector('[data-fav-modal-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function closeModal(modal) {
      modal.classList.remove('is-open');
      setTimeout(function () {
        modal.setAttribute('hidden', '');
      }, 320);
      document.documentElement.classList.remove('v2-fav-modal-lock');
      document.body.classList.remove('v2-fav-modal-lock');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus({ preventScroll: true });
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(btn.dataset.favModalTrigger);
      });
    });

    modals.forEach(function (modal) {
      modal.querySelectorAll('[data-fav-modal-close]').forEach(function (closer) {
        closer.addEventListener('click', function (e) {
          e.preventDefault();
          closeModal(modal);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const openOne = section.querySelector('.v2-favorites__modal.is-open');
      if (openOne) closeModal(openOne);
    });
  });
})();
